import { render, staticRenderFns } from "./DetailsInformations.vue?vue&type=template&id=69cea576&"
import script from "./DetailsInformations.vue?vue&type=script&lang=js&"
export * from "./DetailsInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports